const LyricsDisplay = {
    Original: "original",
    Romanized: "romanized",
    Both: "both"
}

export default LyricsDisplay;
